import styled from 'styled-components';



export const TextPage = styled.div`
  overflow: auto;
  margin: 0.5em;
`;
